var scope_0 = require('/builds/jseto/site-wish-to-go/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/02aa238b5caaf778ccf32d71fed7f8e7.js').default;
var scope_1 = require('/builds/jseto/site-wish-to-go/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/25c38ce51d4f6fe22573a938cd1d36cf.js').default;
var scope_2 = require('/builds/jseto/site-wish-to-go/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9b8fe88f5b303d16ab9d209fa92a04ce.js').default;
var scope_3 = require('/builds/jseto/site-wish-to-go/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a7afe868b1aca38ecab00d9cf02fbdd7.js').default;
var scope_4 = require('/builds/jseto/site-wish-to-go/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ad41b74e102662eda0cd780aaffbd179.js').default;
var scope_5 = require('/builds/jseto/site-wish-to-go/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5 )
    